import styled from "styled-components";

const DragWidget = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
  padding: 1rem;
`;

export default DragWidget;
